import React from "react";
import { AVATAR_GRADIENT, FONT, fieldHeight, h2Style, primaryButton, subStyle } from "./authFlowUi";

const StepDone = ({ mobile, short, first, initials, company, skipped, onContinue }) => (
  <div style={{ animation: "dsRise 420ms cubic-bezier(.22,1,.36,1) both", textAlign: "center", padding: "6px 0 2px" }}>
    <div
      style={{
        width: 76,
        height: 76,
        margin: "0 auto 18px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: AVATAR_GRADIENT,
        boxShadow: "0 14px 30px -14px rgba(139,85,221,.8)",
        animation: "dsPop 420ms cubic-bezier(.22,1,.36,1) both",
      }}
    >
      <span style={{ color: "#fff", font: `600 26px ${FONT}` }}>{initials}</span>
    </div>
    <h2 style={{ ...h2Style, letterSpacing: 0 }}>You're all set, {first}</h2>
    <p style={subStyle("10px 0 24px")}>
      {skipped || !company.trim()
        ? "Your workspace is ready. Your free trial starts now."
        : `Your workspace is set up for ${company.trim()}. Your free trial starts now.`}
    </p>
    <button type="button" onClick={onContinue} style={primaryButton(true, fieldHeight(mobile, short))}>
      Open DocuSensa
    </button>
  </div>
);

export default StepDone;
